export default __webpack_public_path__ + "static/media/console.fca5e905.svg";